import { InfiniteScrollWithQuery } from "shared/ui/infinite-scroll-with-observer/react-query";

import { EmailHistoryComponent } from "@/modules/email-templates-sidebar/content/v2/sections/email-history-section/email-history-component";
import { useFetchEmailHistoryQuery } from "@/modules/email-templates-sidebar/queries";
import { useAccountDetailsContext } from "@/modules/pipeline/account-details/context";
import { DelayedComponent } from "@/components/base/delayed-component";

const ITEMS_PER_PAGE = 50;

export const EmailHistorySection = () => {
  const { campaign, focusedContact } = useAccountDetailsContext();
  const fetchEmailHistoryApi = useFetchEmailHistoryQuery(
    campaign?.id,
    focusedContact?.id
  );

  const { data: emailHistory } = fetchEmailHistoryApi;

  const isHistoryEmpty = emailHistory?.length === 0;

  return (
    <section className="flex flex-col gap-7">
      <InfiniteScrollWithQuery
        api={{ ...fetchEmailHistoryApi, isEmpty: !!isHistoryEmpty }}
      >
        {emailHistory?.map((emailHistoryItem, index) => (
          <DelayedComponent key={index} delay={(index % ITEMS_PER_PAGE) * 100}>
            {({ isReady }) =>
              isReady ? (
                <EmailHistoryComponent
                  key={index}
                  emailHistoryItem={emailHistoryItem}
                />
              ) : null
            }
          </DelayedComponent>
        ))}
      </InfiniteScrollWithQuery>
    </section>
  );
};
